import { useContext } from "react";
import { useParams } from "react-router";

import { SheetScopeContext } from "@/contexts/SheetScopeContext";

export const useCurrentJobId = () => {
  // This is to allow CandidateSheet to be rendered in Aviary
  const sheetContext = useContext(SheetScopeContext);
  const { jobId: routeJobId } = useParams();

  const jobId = sheetContext?.jobId ?? routeJobId;
  if (!jobId) {
    throw new Error("Current job id not found");
  }

  return jobId;
};
